import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';

function renderLangOptions(options) {
    return options.map(option => x `<option value="${option.url}">${option.title}</option>`);
}
function handleLangChange(e) {
    const target = e.target;
    if (!target.value)
        return;
    window.location.href = target.value;
}

export { handleLangChange, renderLangOptions };
